import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Logo from 'common/src/components/UIElements/Logo';
import Container from 'common/src/components/UI/Container';
import FooterWrapper, {
  List,
  ListItem,
  InsightBox,
  FooterBottom
} from './footer.style';
import addToMailchimp from 'gatsby-plugin-mailchimp';

import LogoImage from 'common/src/assets/image/hosting/logo.png';

import { facebook } from 'react-icons-kit/entypo/facebook';
import { instagram } from 'react-icons-kit/entypo/instagram';
import { linkedin } from 'react-icons-kit/entypo/linkedin';
import { youtube } from 'react-icons-kit/entypo/youtube';
import { twitter } from 'react-icons-kit/entypo/twitter';
import { Icon } from 'react-icons-kit';

const Footer = ({
  row,
  col,
  colOne,
  colTwo,
  titleStyle,
  logoStyle,
  textStyle
}) => {
  const Data = useStaticQuery(graphql`
    query {
      hostingJson {
        FOOTER_WIDGET {
          title
          menuItems {
            text
            url
            intercom
          }
        }
      }
    }
  `);

  const [signup, setSignup] = useState({
    email: ''
  });

  const [success, setSuccess] = useState(false);

  const [loading, setLoading] = useState(false);

  const [error, set_error] = useState();

  const validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const _handleSubmit = e => {
    // e.preventDefault();
    setLoading(true);
    addToMailchimp(signup.email) // listFields are optional if you are only capturing the email address.
      .then(data => {
        // I recommend setting data to React state
        // but you can do whatever you want (including ignoring this `then()` altogether)
        console.log(data);
        setLoading(false);
        setSuccess(true);
      })
      .catch(error => {
        setLoading(false);

        console.log(error);
        // unnecessary because Mailchimp only ever
        // returns a 200 status code
        // see below for how to handle errors
      });
  };

  return (
    <FooterWrapper>
      <Container className="footer_container">
        <Box className="row" {...row}>
          <Box {...colOne}>
            <Logo
              href="#"
              logoSrc={LogoImage}
              title="Hosting"
              logoStyle={logoStyle}
            />
            <Text
              style={{ color: '#fff', width: '200px' }}
              content="  101 Jefferson Dr 1 Floor, 
              Menlo Park, CA 94025"
              {...textStyle}
            />
          </Box>
          {/* End of footer logo column */}
          <Box {...colTwo}>
            {Data.hostingJson.FOOTER_WIDGET.map((widget, index) => (
              <Box className="col" {...col} key={`footer-widget-${index}`}>
                <Heading
                  style={{ color: '#fff' }}
                  content={widget.title}
                  {...titleStyle}
                />
                <List>
                  {widget.menuItems.map((item, index) => (
                    <ListItem key={`footer-list-item-${index}`}>
                      {item.intercom ? (
                        <a
                          href="javascript:;"
                          onClick={() => window.Intercom('show')}
                          className="ListItem"
                        >
                          {item.text}
                        </a>
                      ) : (
                        <a href={item.url} className="ListItem">
                          {item.text}
                        </a>
                      )}
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}

            <Box className="col" {...col}>
              <InsightBox style={{ textAlign: 'left' }}>
                <div className="title">Get The Insights That Matter.</div>
                <div className="desc">
                  Latest Updates and News Directly to Your Inbox!
                </div>
                {!success && (
                  <>
                    <input
                      className="input"
                      type="text"
                      placeholder="Email"
                      onChange={e => setSignup({ email: e.target.value })}
                    ></input>
                    {error && <small style={{ color: '#fff' }}>{error}</small>}
                    <button
                      disabled={loading}
                      onClick={() => {
                        if (signup.email) {
                          if (validateEmail(signup.email)) {
                            _handleSubmit(signup.email);
                          } else {
                            set_error('Please provide a valid email id');
                          }
                        } else {
                          set_error('Please provide a email id');
                        }
                      }}
                    >
                      {loading ? 'Loading...' : 'Subscribe'}
                    </button>
                  </>
                )}
                {success && (
                  <div>
                    <br />
                    Thank you for subscribing
                  </div>
                )}
              </InsightBox>
            </Box>
          </Box>
          {/* End of footer List column */}
        </Box>
        <FooterBottom>
          <div className="text">
            2020 @ FlipServe. All rights reserved.{' '}
            <a href="https://news.flipserve.com/terms/">Terms of Use</a>.{' '}
            <a href="https://news.flipserve.com/privacy-policy/">
              Privacy Policy
            </a>
          </div>
          <div className="icon">
            <Icon
              onClick={() => {
                window.open('https://www.facebook.com/goflipserve', '_blank');
              }}
              icon={facebook}
              size={18}
              className="eq-width"
            />
            <Icon
              onClick={() => {
                window.open('https://twitter.com/goflipserve', '_blank');
              }}
              icon={twitter}
              size={18}
              className="eq-width"
            />
            <Icon
              onClick={() => {
                window.open('https://www.instagram.com/goflipserve/', '_blank');
              }}
              icon={instagram}
              size={18}
              className="eq-width"
            />
            <Icon
              onClick={() => {
                window.open(
                  'https://www.linkedin.com/company/flipserve/',
                  '_blank'
                );
              }}
              icon={linkedin}
              size={18}
              className="eq-width"
            />
            <Icon
              onClick={() => {
                window.open(
                  'https://www.youtube.com/channel/UCeMkpPC49sZpsIPfdq2oMPQ',
                  '_blank'
                );
              }}
              icon={youtube}
              size={18}
              className="eq-width"
            />
          </div>
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
};

// Footer style props
Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
  titleStyle: PropTypes.object,
  textStyle: PropTypes.object,
  logoStyle: PropTypes.object
};

// Footer default style
Footer.defaultProps = {
  // Footer row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px'
  },
  // Footer col one style
  colOne: {
    width: [1, '35%', '35%', '23%'],
    mt: [0, '13px'],
    mb: ['30px', 0],
    pl: ['15px', 0],
    pr: ['15px', '15px', 0]
  },
  // Footer col two style
  colTwo: {
    width: ['100%', '65%', '65%', '77%'],
    flexBox: true,
    flexWrap: 'wrap'
  },
  // Footer col default style
  col: {
    width: ['100%', '50%', '50%', '25%'],
    pl: '15px',
    pr: '15px',
    mb: '30px'
  },
  // widget title default style
  titleStyle: {
    color: '#343d48',
    fontSize: '16px',
    fontWeight: '700',
    mb: '30px'
  },
  // Default logo size
  logoStyle: {
    width: '130px',
    mb: '15px'
  },
  // widget text default style
  textStyle: {
    color: '#0f2137',
    fontSize: '16px',
    mb: '10px'
  }
};

export default Footer;
